export const defaultObject: any = {};

export const emptyGuid = '00000000-0000-0000-0000-000000000000';

export const isEmptyString = (data: string): boolean => typeof data === "string" && data.trim().length == 0;
